module.exports = __webpack_public_path__ + "de77a722/img/cadBim.e369a02a.png";